import React from 'react';
import PropTypes from 'prop-types';
import Table from 'cccisd-table';

const OptOutReasonTable = props => {
    const { data } = props;

    return (
        <Table
            data={data.otherReasons?.map((other, i) => ({ other, i }))}
            rowKey="i"
            columns={[{ name: 'other', label: 'Text Response' }]}
            perPage={5000}
            perPageOptions={[250, 500, 1000, 5000]}
            isCsvDownload
            csvFilename="opt-out-other-reasons"
        />
    );
};

OptOutReasonTable.propTypes = {
    data: PropTypes.object,
};

export default OptOutReasonTable;
